// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_carousel.styl
// module id = 97
// module chunks = 0